export default __webpack_public_path__ + "static/media/coffee_cup_01.448b573d.webp";